import {ShouldSkipLazyLoadFn} from 'app/interface';
import {HeaderNavigationConfig} from 'interfaces/structure/components/headerNavigationConfig';

export const shouldSkipLazyLoad: ShouldSkipLazyLoadFn<HeaderNavigationConfig> = ({config}) => {
    return config?.general.userLoginConfiguration ? 'LOAD_EAGER' : 'LOAD_LAZY';
};
